import type { StoreApi } from 'zustand';
import { useStore } from 'zustand';
import { createStore } from './create-store';

/**
 * FRONT-2307: the top bar's "asking you" count, handed to the app shell so it
 * can put the same number on the browser tab (`tab-attention.ts`).
 *
 * The top bar already runs the one `useChatActivity` read that produces this
 * number; a second call elsewhere would register its own polling observers
 * and double every chat-status poll. So the top bar publishes the count here
 * and the layout only reads it.
 */
export interface AttentionStore {
  asking: number;
  setAsking: (n: number) => void;
}

let store: StoreApi<AttentionStore> | undefined;

export function getAttentionStore(): StoreApi<AttentionStore> {
  if (!store) {
    store = createStore<AttentionStore>('attention-store', (set) => ({
      asking: 0,
      setAsking: (n) => set({ asking: n }),
    }));
  }
  return store;
}

export function useAttentionStore<T>(selector: (s: AttentionStore) => T): T {
  return useStore(getAttentionStore(), selector);
}
